// Check screen resolution
function checkScreenResolution() {
  return window.innerWidth <= 999; // Check if screen width is 699px or below
}

// Initialize Swiper based on screen resolution
function initializeSwiper() {
  if (checkScreenResolution()) {
    // If screen resolution is 699px or below
    var swiper = new Swiper(".icon__list--slider", {
      slidesPerView: 1.1,
      spaceBetween: 15,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
    });
  }
}

// Call the function initially
initializeSwiper();

// Add event listener for window resize to reinitialize Swiper if needed
window.addEventListener("resize", function () {
  initializeSwiper();
});



// const observerCallback = (mutations, observer) => {
//   for (const mutation of mutations) {
//     if (mutation.type === 'childList') {
//       console.log('A child node has been added or removed.');
//     } else if (mutation.type === 'attributes') {
//       console.log('The attributes of the target node have changed.');
//       const isSelected = document.querySelector('.product-gallery__media.is-selected');
//       console.log("isSelected", isSelected)
//       if(isSelected){
//         let dataType = isSelected.getAttribute('data-media-type');
//         if(dataType && dataType == 'video'){
//           let video = isSelected.querySelector('video');
//           if (video) {
//             // video.play();
//             // video.setAttribute("playing", "");
//             // video.removeAttribute("suspended");
//           }
//         }
//       }
//     } else if (mutation.type === 'subtree') {
//       console.log('The subtree has been modified.');
//     }
//   }
// };


// const observerOptions = {
//   childList: true,    // Observe direct children additions/removals.
//   attributes: true,   // Observe attribute changes.
//   subtree: true,      // Observe all descendant elements.
//   attributeOldValue: true, // Optional: capture the previous value of the attribute.
//   characterData: true // Observe text content changes.
// };

const observerCallback = (mutations, observer) => {
    for (const mutation of mutations) {
        if (mutation.type === 'attributes') {
            const isSelected = document.querySelector('.product-gallery__media.is-selected');

            if (isSelected) {
                let dataType = isSelected.getAttribute('data-media-type');

                if (dataType === 'video') {
                    let video = isSelected.querySelector('video');

                    if (video) {
                        video.play();
                        video.setAttribute("playing", "");
                        video.removeAttribute("suspended");

                        isSelected.setAttribute('data-media-type', 'image');
                        console.log("Updated data-media-type to image to keep swiper working");
                    }
                }
            }
        }
    }
};

// Start observing the product media gallery for changes
const observer = new MutationObserver(observerCallback);
const targetNode = document.querySelector('.product-gallery__media-list');

if (targetNode) {
    observer.observe(targetNode, { attributes: true, childList: true, subtree: true });
}


const mediaCarousel = document.querySelector('media-carousel');
if (mediaCarousel) {
  const observer = new MutationObserver(observerCallback);
  observer.observe(mediaCarousel, observerOptions);
} else {
  console.log('The .product-gallery element does not exist.');
}


document.addEventListener('DOMContentLoaded', function() {
  let checkedValues = [];
  let checkedText = [];
  
  const optionMenu = document.querySelector(".select__menu"),
    selectBtn = optionMenu.querySelector(".select__btn"),
    options = optionMenu.querySelectorAll(".option"),
    sBtn_text = optionMenu.querySelector(".selectbtn__text");

  if(selectBtn){ 
    selectBtn.addEventListener("click", () =>
      optionMenu.classList.toggle("active")
    );
  }
  if(options){
    options.forEach((option) => {
      option.addEventListener("click", () => {
        let selectedOption = option.querySelector(".option__text");
        if(selectedOption){
          sBtn_text.innerText = selectedOption.innerText;
        }
        // optionMenu.classList.remove("active");
        let dataValue = option.getAttribute('data-value');
        const filterOptionsUl = document.querySelector('.filter_options_ul');
        if (filterOptionsUl) {
            const checkedCheckboxes = filterOptionsUl.querySelectorAll('input[type="checkbox"]:checked');
            checkedValues = Array.from(checkedCheckboxes).map(checkbox => checkbox.value);
            checkedText = Array.from(checkedCheckboxes).map(checkbox => checkbox.getAttribute('data-text'));
            updateDisplayStyles(checkedValues, checkedText)
        }

      });
    });
  }

  // const classesToShow = ['show-class-1', 'show-class-2', 'show-class-3'];

  // Function to update display styles
  function updateDisplayStyles(classesToShow, checkedText) {
      // Hide all elements first
      if(checkedValues?.length > 0){
        document.querySelectorAll('.multi-column__item--custom').forEach(element => {
            element.style.display = 'none';
        });
      }else{
        document.querySelectorAll('.multi-column__item--custom').forEach(element => {
            element.style.display = 'block';
        });
      }
  
      // Show elements that have any of the specified classes
      classesToShow.forEach(className => {
          document.querySelectorAll('.' + className).forEach(element => {
              element.style.display = 'block';
          });
      });

      const selectedTagUlList = document.querySelector('.selected__tag--ul-list');
      let listHtml = ``;
      let svgImg = `<svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="{{ class | strip }}" viewBox="0 0 24 24">
        <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
      </svg>`;
      for (let i = 0; i < checkedText?.length; i++) {
          listHtml += `
            <li class="list__item">
              <div class="tag_info">
                <button type="button" class="close__btn" data-class="${classesToShow[i]}">${svgImg}</button>
                <span>${checkedText[i]}</span>
              </div>
            </li>
          `;
      }
      if (selectedTagUlList) {
          selectedTagUlList.innerHTML = listHtml;
          removeFilter();
      }

      if(checkedValues?.length == 0){
        
      }
  }


  function removeFilter() {
      const tagInfos = document.querySelectorAll('.tag_info');
      // Use .forEach to iterate over the NodeList
      tagInfos.forEach(function (tagInfo) {
          const closeBtns = tagInfo.querySelectorAll('.close__btn');
          // Similarly, use .forEach to iterate over close buttons
          closeBtns.forEach(function (closeBtn) {
              closeBtn.addEventListener('click', function () {
                  let dataClass = closeBtn.getAttribute('data-class');
                  if (dataClass) {
                      let existingInput = document.querySelector(`#${dataClass}`);
                      if (existingInput) {
                          existingInput.checked = !existingInput.checked;
                      }
                  }
                  const filterOptionsUl1 = document.querySelector('.filter_options_ul');
                  if (filterOptionsUl1) {
                      const checkedCheckboxes1 = filterOptionsUl1.querySelectorAll('input[type="checkbox"]:checked');
                      checkedValues = Array.from(checkedCheckboxes1).map(checkbox => checkbox.value);
                      checkedText = Array.from(checkedCheckboxes1).map(checkbox => checkbox.getAttribute('data-text'));
                      updateDisplayStyles(checkedValues, checkedText)
                  }
              });
          });
      });
  }

  removeFilter();
  
  document.addEventListener("click", function(event) {
    var selectMenus = document.querySelectorAll(".select__menu");
    for (var i = 0; i < selectMenus?.length; i++) {
      var selectMenu = selectMenus[i];
      if (!selectMenu.contains(event.target)) {
        selectMenu.classList.remove("active");
      }
    }
  });

  
});
